import { BaseEntityDto } from "@/core/common/entities/base-entity.dto";

export class TrainingCategoryDto extends BaseEntityDto {
  name: string;
}
